import { render, staticRenderFns } from "./spTable.vue?vue&type=template&id=7a2e8c47&"
import script from "./spTable.vue?vue&type=script&lang=js&"
export * from "./spTable.vue?vue&type=script&lang=js&"
import style0 from "./spTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports